import { Controller } from '@hotwired/stimulus';
import { WidgetManager } from '@infakt/widgets/vanilla-sdk';

export default class extends Controller {
  async connect() {
    try {
      this.manager = new WidgetManager();
      await Promise.all([
        this.manager.init({
          name: 'paid-client-onboarding',
          containerId: 'paid-client-onboarding-widget',
        }),
      ]);

      this.manager.mount({
        name: 'paid-client-onboarding',
        containerId: 'paid-client-onboarding-widget',
      });
    } catch (error) {
      console.error('Error in widget controller connect:', error);
      console.error('Error stack:', error.stack);
    }
  }

  disconnect() {
    this.cleanup();
  }

  cleanup() {
    if (this.containerTarget) {
      this.containerTarget.innerHTML = '';
    }
  }
}
